'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_AppPage$DocumentsAuditLogList(docId, pageCursor) {
  this.BJ = null;
  this.z9 = null;
  this.BJ = docId;
  this.z9 = pageCursor;
}
export { $c_Lapp_pages_AppPage$DocumentsAuditLogList as $c_Lapp_pages_AppPage$DocumentsAuditLogList };
$p = $c_Lapp_pages_AppPage$DocumentsAuditLogList.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_AppPage$DocumentsAuditLogList;
/** @constructor */
function $h_Lapp_pages_AppPage$DocumentsAuditLogList() {
}
export { $h_Lapp_pages_AppPage$DocumentsAuditLogList as $h_Lapp_pages_AppPage$DocumentsAuditLogList };
$h_Lapp_pages_AppPage$DocumentsAuditLogList.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_AppPage$DocumentsAuditLogList)) {
    var x = this.BJ;
    var x$2 = x$0.BJ;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.z9;
      var x$4 = x$0.z9;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "DocumentsAuditLogList";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.BJ;
  }
  if ((n === 1)) {
    return this.z9;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "docId";
  }
  if ((n === 1)) {
    return "pageCursor";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_pages_AppPage$DocumentsAuditLogList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k6)));
}
export { $isArrayOf_Lapp_pages_AppPage$DocumentsAuditLogList as $isArrayOf_Lapp_pages_AppPage$DocumentsAuditLogList };
var $d_Lapp_pages_AppPage$DocumentsAuditLogList = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_AppPage$DocumentsAuditLogList, "app.pages.AppPage$DocumentsAuditLogList", ({
  k6: 1,
  aB: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_pages_AppPage$DocumentsAuditLogList as $d_Lapp_pages_AppPage$DocumentsAuditLogList };
//# sourceMappingURL=app.pages.-App-Page$-Documents-Audit-Log-List.js.map
